export default __webpack_public_path__ + "static/media/Karakteristike Terminalne Opreme.75892642.pdf";